<template>
  <pop-over v-if="showContextMenu" :bounds="contextMenuBounds" :width="240">
    <div
      v-click-outside="handleCloseContextMenu"
      class="context-menu"
      @click="handleCloseContextMenu"
    >
      <div v-ripple class="context-menu-link" @click="handleNewLocationClick">
        <v-row dense>
          <v-col class="shrink"><v-icon>add_location_alt</v-icon></v-col>
          <v-col>
            <vs-text>New location here</vs-text>
          </v-col>
        </v-row>
      </div>
    </div>
  </pop-over>
</template>

<script setup lang="ts">
import PopOver from '@/components/common/PopOver.vue'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import mapboxgl from 'mapbox-gl'
import { useMap } from '../mapbox/context'
import { useRoute, useRouter } from 'vue-router/composables'
import { useStore } from 'vuex-composition-helpers'

const store = useStore()
const isAdmin = computed(() => store.getters['permissions/isAdmin'])
const contextMenuBounds = ref({ top: 0, left: 0, height: 0 })
const showContextMenu = ref(false)
const lastMapCoordinatesFromClick = ref<mapboxgl.LngLatLike>()

const { map } = useMap()
const router = useRouter()
const route = useRoute()

onMounted(() => {
  map.value?.on('contextmenu', handleOpenContextMenu)
  map.value?.on('dragstart', handleCloseContextMenu)
  map.value?.on('zoomstart', handleCloseContextMenu)
})

onBeforeUnmount(() => {
  map.value?.off('contextmenu', handleOpenContextMenu)
  map.value?.off('dragstart', handleCloseContextMenu)
  map.value?.off('zoomstart', handleCloseContextMenu)
})

const handleOpenContextMenu = (event) => {
  if (!isAdmin.value || route.name === 'fvnext-new-location') return
  showContextMenu.value = true
  contextMenuBounds.value.left = event.originalEvent.x
  contextMenuBounds.value.top = event.originalEvent.y

  lastMapCoordinatesFromClick.value = event.lngLat
}

const handleCloseContextMenu = () => {
  showContextMenu.value = false
}

const handleNewLocationClick = () => {
  if (route.name === 'fvnext-new-location') return
  router.push({
    name: 'fvnext-new-location',
    params: {
      defaultLat: (lastMapCoordinatesFromClick.value as any).lat,
      defaultLng: (lastMapCoordinatesFromClick.value as any).lng,
    },
  })

  // the animation of moving the map is less jarring with a small delay
  setTimeout(() => {
    map.value?.flyTo({
      center: lastMapCoordinatesFromClick.value,
    })
  }, 300)
}
</script>

<style scoped>
.context-menu {
  margin: calc(-1 * var(--space-base));
  padding: var(--space-small) 0;
}

.context-menu-link {
  display: block;
  text-decoration: none;
  padding: var(--space-small) var(--space-base);
  color: var(--color-grey--dark);
  cursor: pointer;
}

.context-menu-link:hover {
  background-color: var(--color-silver);
}
</style>
